import { render, staticRenderFns } from "./loyalty.vue?vue&type=template&id=2cfd5a64&scoped=true&"
import script from "./loyalty.vue?vue&type=script&lang=ts&"
export * from "./loyalty.vue?vue&type=script&lang=ts&"
import style0 from "./loyalty.scss?vue&type=style&index=0&id=2cfd5a64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfd5a64",
  null
  
)

component.options.__file = "loyalty.vue"
export default component.exports